import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SeoPageService } from '@seo/feature';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdHeadingComponent {
  heading$: Observable<string | null> = this.seoPageService.getSeoPage().pipe(
    map((seo) => {
      if (!seo?.heading && !seo?.title) {
        return null;
      }

      return seo.heading || seo.title || '';
    }),
  );

  loading$: Observable<boolean> = this.seoPageService.isLoading();

  constructor(private seoPageService: SeoPageService) {}
}
